<template>
  <page :setup="setup">
    <container-layout :menu="[{ type: '财务评价' }]">
      <template v-slot:aside>
        <div class="fin-aside">
          <div class="fix-top">
            <el-input v-model="unrelateSearch" size="mini" placeholder="关键字">
              <el-button
                slot="append"
                icon="el-icon-search"
                style="margin: -10px 0px -10px -20px; color: #fff"
                title="搜索"
              ></el-button>
            </el-input>
            <div class="tool">
              <span @click="addDialogVisible = true" title="添加项目">
                <i class="el-icon-plus"></i>
              </span>
            </div>
          </div>
          <div class="tree-container">
            <el-tree
              ref="unrelateTree"
              node-key="id"
              :data="filteredUnrelateData"
              :default-expanded-keys="expandedKeys"
              :render-content="renderContent"
              show-checkbox
              @node-click="clickNode"
            ></el-tree>
          </div>
          <div class="bottom-tool fix-bottom">
            <div>
              <el-button type="text" @click="exportReport">导出报告</el-button>
              <el-button type="text" @click="compareEco">
                {{
                  mode === 'compare' && selectEcos.length > 1
                    ? '退出对比'
                    : '对比'
                }}
              </el-button>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:main>
        <div class="main-content">
          <detail
            v-if="mode === 'detail'"
            :formData="formData"
            :economic="currentEco"
            :project="currentProject"
          ></detail>
          <fin-form
            v-else-if="mode === 'add' || mode === 'edit'"
            ref="form"
            :defaultData="defaultData"
            :formData="formData"
            :economic="currentEco"
            :project="currentProject"
            @refreshUnrelate="fetchUnrelate"
            @landChange="landChange"
            @reset="reset"
            @save="save"
          ></fin-form>
          <div v-else>
            <el-tabs v-model="detailTab">
              <el-tab-pane label="关键财务指数汇总表" name="compare">
                <div class="title">
                  {{ compareTitle }}
                </div>
                <compare-table :ecos="selectEcos"></compare-table>
              </el-tab-pane>
              <el-tab-pane
                label="敏感性分析结果"
                name="sensitivity"
                v-if="!(mode === 'compare' && selectEcos.length > 1)"
              >
                <div class="title">
                  {{ selectEcos[0].projectName }}-{{ selectEcos[0].name }}
                </div>
                <sensitivity :eco="sensitivityEco"></sensitivity>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <el-dialog
          v-drag:common
          custom-class="add-project-dialog transtant-input"
          title="添加项目"
          :visible.sync="addDialogVisible"
          :modal="false"
          width="35%"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          append-to-body
          center
        >
          <el-form label-width="100px">
            <el-form-item label="项目名称：">
              <el-input
                v-model="addingProjectName"
                placeholder="请输入项目名称"
                :maxlength="30"
              ></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="addDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="addProject">确定</el-button>
          </span>
        </el-dialog>
      </template>
    </container-layout>
  </page>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

import { getToken } from '@/utils';
import CompareTable from './components/compare-table';
import Sensitivity from './components/sensitivity';
import Detail from './components/detail';
import { filterTree, getTreeKeys, convertUnrelateTree } from './util';

const ARR_KEY = {
  incomeTaxRate: 'incomeTaxType',
  maintainData: 'maintainNum',
  insureData: 'insureNum',
  materialConsumption: 'materialNum',
  otherFee1: 'otherFeeNum',
  otherFee2: 'otherFeeNum',
  depreciableData: 'depreciableType'
};
const ARR_KEY_VALUE = {
  depreciableData: 2
};
const ARR_KEY_POSTFIX = {
  energyData: '_Arr',
  totalInvestArr: '_Arr',
  energyDataArr: '_Arr',
  priceWithArr: '_Arr',
  loanInterestRateArr: '_Arr'
};

export default {
  components: {
    CompareTable,
    Sensitivity,
    Detail
  },
  data() {
    return {
      mainContent: 'main-form',
      selectEcos: [],
      formData: null,
      unrelateSearch: '',
      relateData: [],
      unrelateData: [],
      formArrKey: [
        'constructionInvest',
        'otherAssets',
        'immaterialAssets',
        'incomeTaxRate',
        'maintainData',
        'insureData',
        'materialConsumption',
        'otherFee1',
        'otherFee2',
        'ongridCapacity',
        'staffCapacity',
        'staffSalary',
        'welfareRate',
        'depreciableData',
        'energyData',
        'totalInvestArr',
        'energyDataArr',
        'priceWithArr',
        'loanInterestRateArr'
      ],
      addDialogVisible: false,
      editingValue: '',
      addingProjectName: '',
      detailTab: 'compare',
      expandedKeys: [],
      currentNode: null,
      mode: 'add', // detail,compare,add,edit
      defaultParam: {},
      currentDefaultParam: {}
    };
  },
  computed: {
    filteredUnrelateData() {
      const { unrelateData, unrelateSearch } = this;
      return filterTree(unrelateData, unrelateSearch);
    },
    sensitivityEco() {
      if (isEmpty(this.selectEcos) || this.selectEcos.length !== 1) return null;
      return this.selectEcos[0];
    },
    compareTitle() {
      return !isEmpty(this.selectEcos) && this.selectEcos.length === 1
        ? `${this.selectEcos[0].projectName}-${this.selectEcos[0].name}`
        : '对比';
    },
    currentProject() {
      if (this.currentNode?.type === 'project') {
        return this.currentNode;
      }
      return null;
    },
    currentEco() {
      if (this.currentNode?.type === 'eco') {
        return this.currentNode;
      }
      return null;
    },
    defaultData() {
      if (this.currentNode?.type === 'eco') {
        //console.log('currentDefaultParam', this.currentDefaultParam);
        return this.currentDefaultParam;
      }
      //console.log('defaultParam', this.defaultParam);
      return this.defaultParam;
    }
  },
  methods: {
    async setup() {
      await Promise.all([this.fetchUnrelate(), this.fetchDefaultParam()]);
    },
    async landChange(landOrSea) {
      await this.fetchDefaultParam(landOrSea, true);
      this.formData = {
        ...this.defaultParam,
        name: this.formData.name,
        projectId: this.formData.projectId,
        projectName: this.formData.projectName
      };
      //console.log('current form', this.formData);
    },
    async fetchDefaultParam(landOrSea, showLoading) {
      const res = await this.$fetch({
        url: '/windfarm/economic/getDefaultParam',
        params: {
          landOrSea
        },
        showLoading
      });
      this.defaultParam = this.prefixParam(res.data.defaultParam);
    },
    async fetchUnrelate(showLoading) {
      const res = await this.$fetch({
        url: '/windfarm/economic/getMenu2',
        showLoading
      });
      this.unrelateData = convertUnrelateTree(res.data.projectList);
      if (this.currentNode) {
        this.expandedKeys = this.currentNode.parent
          ? [this.currentNode.parent.id]
          : [this.currentNode.id];
        this.$nextTick(() => {
          this.setCurrentKey();
        });
      }
    },
    setCurrentKey() {
      if (!this.currentNode) return;
      this.getTree().setCurrentKey(this.currentNode.id);
    },
    async getEconomic(eco) {
      const [res, totalInvestRes] = await Promise.all([
        this.$fetch('/windfarm/economic/getEconomicPlan', {
          params: { economicId: eco.rawId },
          showError: true,
          showLoading: true
        }),
        this.$fetch('/windfarm/economic/getTotalInvestDetail', {
          params: {
            economicId: eco.rawId,
            planId: 0
          },
          showError: true
        })
      ]);
      const data = this.prefixParam(res.data.economicPlan);
      data.totaInvestDetailList =
        totalInvestRes.data?.totalInvestDetailList || [];
      this.currentDefaultParam = data;
      this.reset();
      return res.data.economicPlan;
    },
    getTree() {
      return this.$refs.unrelateTree;
    },
    getTreeData() {
      return this.unrelateData;
    },
    leftCheckAll() {
      const tree = this.getTree();
      const treeData = this.getTreeData();
      const keys = getTreeKeys(treeData);
      tree.setCheckedKeys(keys);
    },
    leftUnCheckAll() {
      const tree = this.getTree();
      tree.setCheckedKeys([]);
    },
    getSelectNodes() {
      const tree = this.getTree();
      const nodes = tree.getCheckedNodes();
      return nodes.filter(node => node.type === 'eco');
    },
    async compareEco() {
      if (this.mode === 'compare' && this.selectEcos.length > 1) {
        this.mode = 'add';
        return;
      }
      const nodes = this.getSelectNodes();
      if (isEmpty(nodes)) {
        this.$message('请选择财务评价方案');
        return;
      }
      this.selectEcos = await Promise.all(
        nodes.map(node => this.getEconomic(node))
      );
      this.mode = 'compare';
      this.detailTab = 'compare';
    },
    async showDetail(eco, e) {
      e.stopPropagation();
      const res = await this.getEconomic(eco);
      this.selectEcos = [res];
      this.currentNode = eco;
      this.setCurrentKey();
      this.mode = 'compare';
    },
    prefixParam(data) {
      const formData = { ...data };
      this.formArrKey.forEach(key => {
        const value = formData[key];
        formData[`${key}${ARR_KEY_POSTFIX[key] || 'Arr'}`] =
          typeof value === 'string' ? value.split(',') : [];
      });
      return formData;
    },
    async save() {
      try {
        const data = {
          ...this.formData,
          economicId:
            this.currentNode?.type === 'eco' ? this.currentNode.rawId : 0,
          whetherLcoe: 1
        };
        if (!data.projectId) {
          data.projectId = this.currentNode?.rawId;
          data.projectName = this.currentNode?.label;
        }
        this.formArrKey.forEach(key => {
          const arrKey = `${key}${ARR_KEY_POSTFIX[key] || 'Arr'}`;
          if (ARR_KEY[key]) {
            if (+data[ARR_KEY[key]] === (ARR_KEY_VALUE[key] || 1)) {
              const value = data[arrKey];
              data[key] = value.join(',');
            }
          } else {
            data[key] = data[arrKey].join(',');
          }
          data[arrKey] = null;
        });
        if (typeof data.constructionStarttime === 'string') {
          if (data.constructionStarttime?.indexOf('-01') === -1) {
            data.constructionStarttime += '-01';
          }
        } else {
          data.constructionStarttime =
            this.$moment(data.constructionStarttime).format('YYYY') + '-01';
        }
        if (!data.whetherSense) {
          data.energyDataArr = null;
          data.totalInvestArr = null;
          data.priceWithArr = null;
          data.loanInterestRateArr = null;
        }
        console.log('before submit', data);
        const res = await this.$fetch({
          url: '/windfarm/economic/saveEconomicPlan',
          data,
          method: 'post',
          showError: true,
          showLoading: true,
          showSuccess: true
        });
        this.mode = 'compare';
        const eco = res.data.data;
        if (!eco.projectName) {
          eco.projectName = data.projectName;
        }
        this.selectEcos = [eco];
        this.fetchUnrelate(true);
      } catch (e) {
        //console.log('submit err', e);
      }
    },
    reset() {
      if (this.currentNode?.type === 'eco') {
        this.formData = { ...this.currentDefaultParam };
      } else {
        this.formData = { ...this.defaultParam };
      }
      //console.log('reset current form', this.formData);
    },
    async addProject() {
      if (!this.addingProjectName) {
        this.$message('请填写项目名称');
        return;
      }
      const res = await this.$postForm('/windfarm/economic/saveProjectName', {
        data: { projectName: this.addingProjectName },
        showError: true,
        showLoading: true,
        showSuccess: true
      });
      this.addingProjectName = '';
      this.addDialogVisible = false;
      if (res.data.project) {
        const projectId = res.data.project.projectId;
        this.currentNode = {
          id: `project-${projectId}`,
          rawId: projectId,
          type: 'project'
        };
      }
      this.formData = null;
      this.fetchUnrelate(true);
    },
    clickNode(data) {
      this.currentNode = data;
      this.mode = 'detail';
      if (data.type === 'eco') {
        this.getEconomic(data);
      } else {
        this.formData = null;
      }
    },
    async editNode(data, e) {
      e.stopPropagation();
      if (!data) {
        this.mode = 'add';
        return;
      }
      this.editingValue = data.label;
      this.currentNode = data;
      this.setCurrentKey();
      if (data.type === 'eco') {
        await this.getEconomic(data);
      }
      this.mode = 'edit';
    },
    async editNodeSave(data, e) {
      e.stopPropagation();
      if (this.editingValue?.length > 30) {
        this.$message('项目名称长度不能超过30');
        return;
      }
      if (data.type === 'eco') {
        await this.$postForm('/windfarm/economic/updateEconomicName', {
          data: {
            economicId: data.rawId,
            economicName: this.editingValue,
            projectId: data.parent.rawId
          },
          showError: true,
          showLoading: true,
          showSuccess: true
        });
      } else {
        await this.$postForm('/windfarm/economic/updateProjectName', {
          data: { projectId: data.rawId, projectName: this.editingValue },
          showError: true,
          showLoading: true,
          showSuccess: true
        });
      }
      this.expandedKeys = data.parent ? [data.parent.id] : [];
      data.label = this.editingValue;
      this.editingValue = '';
      this.mode = 'add';
    },
    async removeNode(data, e) {
      e.stopPropagation();
      this.$confirm('确定删除吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(async () => {
        if (data.type === 'eco') {
          await this.$postForm('/windfarm/economic/delEconomics', {
            data: { economicIds: data.rawId },
            showError: true,
            showLoading: true,
            showSuccess: true
          });
        } else {
          await this.$postForm('/windfarm/economic/delProject', {
            data: { projectId: data.rawId },
            showError: true,
            showLoading: true,
            showSuccess: true
          });
        }
        await this.fetchUnrelate();
        this.formData = null;
        if (data.parent) {
          this.currentNode = data.parent;
          this.expandedKeys = [data.parent.id];
        } else {
          this.currentNode = null;
        }
      });
    },
    addFin(data, e) {
      e.stopPropagation();
      this.currentNode = data;
      this.mode = 'add';
      this.setCurrentKey();
      this.reset();
    },
    renderContent(h, { node, data }) {
      const editing =
        this.mode === 'edit' &&
        this.currentNode?.id === data.id &&
        this.currentNode?.type === 'project';
      return (
        <div class="custom-tree-node" id={data.id}>
          <div title={node.label} class="custom-tree-node-label">
            {editing ? (
              <input
                value={this.editingValue}
                class="el-input__inner"
                onChange={e => (this.editingValue = e.target.value)}
                onClick={e => e.stopPropagation()}
                style={{ width: '120px' }}
              ></input>
            ) : (
              <span>{node.label || '--'}</span>
            )}
          </div>
          <div style="margin: auto;">
            {data.isOwnerFlag === 1 && (
              <span>
                {editing ? (
                  <span
                    class="tree-action-icon"
                    onClick={e => this.editNodeSave(data, e)}
                  >
                    <i class="el-icon-check"></i>
                  </span>
                ) : (
                  <span
                    class="tree-action-icon"
                    title="编辑"
                    onClick={e => this.editNode(data, e)}
                  >
                    <i class="el-icon-edit-outline"></i>
                  </span>
                )}
                {editing ? (
                  <span
                    class="tree-action-icon"
                    title="编辑"
                    onClick={e => this.editNode(null, e)}
                  >
                    <i class="el-icon-close"></i>
                  </span>
                ) : (
                  <span
                    class="tree-action-icon"
                    title="删除"
                    onClick={e => this.removeNode(data, e)}
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                )}
                {data.type === 'project' && (
                  <span
                    class="tree-action-icon"
                    title="添加"
                    onClick={e => this.addFin(data, e)}
                  >
                    <i class="el-icon-plus"></i>
                  </span>
                )}
              </span>
            )}
            {data.type === 'eco' && !editing && (
              <span
                class="tree-action-icon"
                title="结果"
                onClick={e => this.showDetail(data, e)}
              >
                <i class="el-icon-document"></i>
              </span>
            )}
          </div>
        </div>
      );
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      let ids = [];
      this.multipleSelection.map(item => {
        ids.push(item.economicId);
      });
      this.selectedIDs = ids.join(',');
    },
    exportReport() {
      const nodes = this.getSelectNodes();
      if (isEmpty(nodes)) {
        this.$message('请选择财务评价方案');
        return;
      }
      if (nodes.length > 1) {
        this.$message('一次只能导出一个方案');
        return;
      }
      const url = `${
        process.env.VUE_APP_API_HOST
      }/windfarm/economic/report/downReport?economicId=${
        nodes[0].rawId
      }&apiKey=${getToken()}`;
      window.open(url, '_parent');
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-tree {
  background: @bgColor;

  & > .el-tree-node {
    & > .el-tree-node__content {
      .el-checkbox {
        display: none !important;
      }
    }

    .el-tree-node__content {
      background: @bgColor;
      color: #fff;
      height: 36px;
      border-bottom: 1px dashed #666;
    }

    .tree-action-icon {
      display: inline-block;
      margin: 0 4px;
      text-align: right;
    }
  }

  .el-tree-node {
    &.is-current {
      > .el-tree-node__content {
        background: @blue;
      }
    }
  }

  .custom-tree-node {
    display: flex;
    width: 100%;
    padding: 2px 4px;

    .custom-tree-node-label {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
      white-space: normal;
    }
  }
}

.fin-aside {
  background: @bgColor;
  color: #fff;

  .fix-top {
    width: 260px;
    position: fixed;
    z-index: 1000;
    box-sizing: border-box;
    background-color: #3b3a39;
  }

  /deep/.el-input-group__append {
    border: none;
    background-color: transparent;
    border-bottom: 1px solid #fff;
    font-size: 18px;
  }

  /deep/.el-input__inner {
    background-color: transparent;
    color: #fff;
    border: none;
    border-bottom: 1px solid #fff;
    height: 30px;
  }

  .tree-container {
    margin-bottom: 30px;
    padding-top: 30px;
  }

  .tool {
    position: absolute;
    top: 0px;
    right: 4px;
    cursor: pointer;
    font-size: 20px;
    z-index: 1;
    height: 30px;

    &:hover {
      color: #409eff;
    }
  }

  /deep/.el-input-group {
    .el-input-group__append {
      border: 0;
    }
  }
}

.unrelate-list-item {
  display: flex;

  .unrelate-title {
    flex: 1;
  }

  .unrelate-tool {
    cursor: pointer;

    &:hover {
      color: #409eff;
    }
  }
}

.bottom-tool {
  font-size: 4px;
  position: absolute;
  bottom: 0px;
  right: 0px;
  left: 0px;
  background-color: #003e8e;
  text-align: right;
  color: #000000;
  height: 28px;
  line-height: 28px;

  > div {
    margin-right: 30px;
  }

  /deep/.el-button {
    color: #fff;
    padding: 3px 2px;
    font-size: 14px;
  }

  &.fix-bottom {
    width: 260px;
    position: fixed;
    z-index: 1000;
  }
}

/deep/.main-content {
  color: #fff;
  height: 100%;

  .title {
    padding-left: 14px;
    line-height: 26px;
    background-color: #003e8e;
  }
  .el-tabs__nav-wrap {
    display: flex;
    justify-content: flex-end;
    padding-right: 16px;
    // background-color: #0477a1;
    align-items: center;
    // padding: 1px;
    height: 26px;
    font-size: 12px;
    margin-bottom: 3px;

    .el-tabs__item {
      height: 28px;
      line-height: 28px;
      font-size: 12px;
    }
  }
  .el-tabs__nav-wrap::after {
    height: 0px;
  }
  /deep/.el-tabs {
    .el-tabs__header {
      margin: 0;
      .el-tabs__active-bar {
        background-color: transparent !important;
      }
      .el-tabs__item {
        color: #fff;
        padding: 0 10px;
        background-color: #3b3a39;
        margin-left: 2px;
        &.is-active {
          background: @brandColor;
        }
      }
    }
  }
}

/deep/.el-input__inner {
  color: #000;
  border-radius: 0px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #ffffff;
  color: #ffffff;
  font-size: 12px;
  text-align: center;
}

/deep/.el-input-group__append {
  background-color: #fff;
  border-radius: 0px;
}
</style>

<style lang="less">
.add-project-dialog {
  text-align: left;
  .el-form-item__label {
    color: #fff;
  }
  .el-dialog__footer {
    text-align: right;
  }
}
</style>
